import React from "react";

const ColorSelectionContext = React.createContext();
const ColorSelectionProvider = ColorSelectionContext.Provider;
const ColorSelectionConsumer = ColorSelectionContext.Consumer;

export {
  ColorSelectionContext,
  ColorSelectionProvider,
  ColorSelectionConsumer,
};
